const data = [
    { 
      id: 1, 
      name: "Pendente"
    },
    { 
      id: 2, 
      name: "Em andamento"
    },
    { 
      id: 3, 
      name: "Finalizado"
    },
    { 
      id: 4, 
      name: "Erro"
    },
  ];
  
  export default [...data];